import React from "react";
import DownloadableFileItem from "../downloadableFileItem/downloadableFileItem.js";
import "./style.css";
export default function DownloadableFileList(props) {
    return (React.createElement("div", { className: "downloadable-file-list-container" }, props.files.map((file, index) => (React.createElement(DownloadableFileItem, { file: file, key: index })))));
}
